export const DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_FORMAT = 'h:mma';
